<template>
  <div id="app">
    <header><Navbar /></header>
    <main><router-view :key="$route.path"></router-view></main>
    <cxt-Footer />
  </div>
</template>

<script>
import Navbar from 'Components/Navbar';
import cxtFooter from 'Components/cxt-Footer';
import store from '@/store';
import '@/clients/apiAuth';

export default {
  name: 'app',
  components: {
    Navbar,
    cxtFooter,
  },
  created: function() {
    store.dispatch('refreshUser');
  },
};
</script>

<style lang="scss">
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  > main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
